import * as React from 'react';
import { fromEvent, Subscription } from 'rxjs';
import memoizeOne from 'memoize-one';
import { styles } from './styles';
import { DesignShowcase_designShowcase_exhibits } from '@graphql/designShowcaseTypes';
import { DesignExhibitItem } from './components/DesignExhibitItem';
import { Columns } from '@joykit';
import { buildReactStateHandler, isEqual } from '@lib';
import { filter } from 'rxjs/operators';
// import { CustomizeYourOwn } from './components/CustomizeYourOwn';

const stateUpdater = buildReactStateHandler<State>();
interface Props {
  batchSize: number;
  exhibits: DesignShowcase_designShowcase_exhibits[];
  onStartHereClick: React.MouseEventHandler<HTMLElement>;
  onPreviewThisClick: React.MouseEventHandler<HTMLElement>;
  showDesktopButtons: boolean;
}

type State = {
  hasReachedEnd: boolean;
  offset: number;
};

export class DesignExhibitList extends React.Component<Props, State> {
  static defaultProps = {
    batchSize: 15
  };

  readonly state: State = {
    hasReachedEnd: this.props.batchSize >= this.props.exhibits.length,
    offset: 1
  };

  containerRef = React.createRef<HTMLDivElement>();
  scrollSub: Subscription;
  isLoadingNextBatch = false;

  componentDidMount() {
    this.scrollSub = fromEvent(document, 'scroll')
      .pipe(filter(e => !!this.containerRef.current && !this.isLoadingNextBatch && !this.state.hasReachedEnd))
      .subscribe(() => {
        this.processExhibitList();
      });
    this.processExhibitList();
  }

  componentWillUnmount() {
    if (this.scrollSub) {
      this.scrollSub.unsubscribe();
    }
  }

  processExhibitList = () => {
    if (this.containerRef.current && !this.isLoadingNextBatch && !this.state.hasReachedEnd) {
      const BUFFER = 500;
      const hasReachedEnd = document.body.scrollTop + document.body.clientHeight >= document.body.scrollHeight - BUFFER;
      if (hasReachedEnd) {
        this.isLoadingNextBatch = true;
        this.setState(
          stateUpdater(draft => {
            const currentOffset = draft.offset;
            const nextOffset = currentOffset + 1;
            draft.offset = nextOffset;
            draft.hasReachedEnd = nextOffset * this.props.batchSize >= this.props.exhibits.length;
          }),
          () => {
            window.requestAnimationFrame(() => {
              this.isLoadingNextBatch = false;
            });
          }
        );
      }
    }
  };

  loadNextBatch = memoizeOne((offset: number, batchSize: number) => {
    return this.props.exhibits.slice(0, batchSize * offset);
  }, isEqual);

  render() {
    const { onStartHereClick, batchSize, onPreviewThisClick, showDesktopButtons } = this.props;
    const { offset } = this.state;
    const displayedExhibits = this.loadNextBatch(offset, batchSize);
    return (
      <div className={styles.container} ref={this.containerRef}>
        <Columns multiline={true} stackOnMobile={true}>
          {/* <CustomizeYourOwn /> */}
          {displayedExhibits.map(({ exhibitId, thumbnail, spec, aspectRatio }) => {
            return (
              <DesignExhibitItem
                key={exhibitId}
                exhibitId={exhibitId}
                aspectRatio={aspectRatio}
                thumbnailUrl={thumbnail && thumbnail.url}
                layout={spec!.websiteLayout!.template}
                style={spec!.style!.name}
                onStartHereClick={onStartHereClick}
                onPreviewThisClick={onPreviewThisClick}
                showDesktopButtons={showDesktopButtons}
              />
            );
          })}
        </Columns>
      </div>
    );
  }
}
